"use client";

import React from "react";

import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { SecuredFooter } from "./ui/secured-footer";
import payFailIcon from "../assets/icons/pay_fail_icon.svg";

const PaymentFailed = ({ onTryAgain }) => {
  const handleTryAgain = () => {
    if (onTryAgain) {
      onTryAgain();
    }
  };

  return (
    <Card className="w-full bg-white rounded-2xl border border-[#EBE9EF] !shadow-none relative">
      <CardContent className="px-6 py-12 w-full">
        <div className="flex flex-col items-center justify-center text-center min-h-[400px]">
          {/* Fail Icon */}
          <div className="mb-8">
            <img
              src={payFailIcon}
              alt="Payment Failed"
              width={104}
              height={104}
            />
          </div>

          {/* Title */}
          <h1 className="text-[32px] font-semibold text-[#33125F] leading-[40px] mb-6">
            Transaction failed
          </h1>

          {/* Subtitle */}
          <p className="text-[20px] text-[#423E51] leading-[32px] max-w-[499px]">
            Your payment was not successful. Please try again. If the problem
            persists, please contact support.
          </p>
        </div>
      </CardContent>

      {/* Try Again Button */}
      <div className="flex justify-center w-full px-6 pb-8">
        <Button
          onClick={handleTryAgain}
          className="py-3 px-16 h-[48px] w-[176px] text-[14px] font-semibold text-white rounded-full bg-[linear-gradient(70.19deg,#57249C_10.66%,#EB3366_113.47%)] hover:opacity-90"
        >
          Try Again
        </Button>
      </div>

      <SecuredFooter />
    </Card>
  );
};

export default PaymentFailed;
